import React from 'react';
import { SvgType } from '../svgType';

export default ({ className, color = '#333334' }: SvgType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.414"
    height="16.829"
    viewBox="0 0 9.414 16.829"
    className={className}
  >
    <path
      d="M0,0,7,7,0,14"
      transform="translate(1.414 1.414)"
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);
